// tray-up export icon: arrow pointing up out of a U-shaped tray
const Icon = (props) => (
	<svg
		width={props.width}
		height={props.height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill={props.color}
			d="M11 4H13V14H11V4ZM11 4L6.5 8.5L7.91 9.91L11 6.83V4ZM13 4V6.83L16.09 9.91L17.5 8.5L13 4ZM4 14V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V14H18V19H6V14H4Z"
		/>
	</svg>
);

export default Icon;
